<mat-form-field
  appearance="outline"
  class="munily-text-field munily-time-input-field"
  [class.mat-form-field-disabled]="disabled"
>
  <mat-label *ngIf="label">
    {{ label }}<span *ngIf="required" class="munily-time-input-field__required-mark">*</span>
  </mat-label>

  <div
    class="munily-time-input-field__time-selects"
    (blur)="onTimeTouched()"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
  >
    <mat-select
      class="munily-time-input-field__time-part"
      [placeholder]="'HH'"
      [formControl]="hourCtrl"
      [panelClass]="'munily-time-input-field__time-panel'"
      yPosition="below"
      (click)="$event.stopPropagation()"
    >
      <mat-option *ngFor="let hh of hourOptions" [value]="hh">{{ hh }}</mat-option>
    </mat-select>

    <span class="munily-time-input-field__colon" aria-hidden="true">:</span>

    <mat-select
      class="munily-time-input-field__time-part"
      [placeholder]="'MM'"
      [formControl]="minuteCtrl"
      [panelClass]="'munily-time-input-field__time-panel'"
      yPosition="below"
      (click)="$event.stopPropagation()"
    >
      <mat-option *ngFor="let mm of minuteOptions" [value]="mm">{{ mm }}</mat-option>
    </mat-select>
  </div>

  <div
    matSuffix
    class="munily-time-input-field__suffix-container"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
  >
    <div class="munily-time-input-field__vertical-divider" aria-hidden="true"></div>
    <mat-select
      class="munily-time-input-field__meridiem"
      [formControl]="meridiemCtrl"
      [panelClass]="'munily-time-input-field__meridiem-panel'"
      yPosition="below"
    >
      <mat-option value="AM">AM</mat-option>
      <mat-option value="PM">PM</mat-option>
    </mat-select>
  </div>

  <mat-error *ngIf="firstErrorMessage">
    {{ firstErrorMessage }}
  </mat-error>
</mat-form-field>
